export default __webpack_public_path__ + "static/media/logo-atom.692647ef.png";